var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FilledInput, makeStyles, MenuItem, Select, Tooltip, withStyles } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Linked, useLinked } from '@type-r/react';
import * as React from 'react';
import { useContext } from 'react';
import { colors } from '../common';
import { Input, ReadOnly } from './inputs';
export var Option = MenuItem;
var ErrorTooltip = withStyles({
    tooltip: {
        color: 'white',
        backgroundColor: '#FF274B',
        padding: 10,
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 600,
    },
    arrow: {
        color: '#FF274B',
    },
})(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(Tooltip, __assign({ placement: "top-end", arrow: true }, props));
});
var BaseSelectInput = withStyles({
    root: {},
    input: {},
    inputRoot: {
        flexGrow: 1
    },
    errorIcon: {
        margin: 'auto 0'
    }
})(function (_a) {
    var $value = _a.$value, classes = _a.classes, error = _a.error, props = __rest(_a, ["$value", "classes", "error"]);
    return (React.createElement("div", { className: classes.root },
        $value ?
            React.createElement(FilledInput, __assign({ classes: {
                    root: classes.inputRoot,
                    input: classes.input
                }, value: $value.value == null ? '' : $value.value, onChange: function (e) { return $value.set(e.target.value); } }, props, { disableUnderline: true }))
            :
                React.createElement(FilledInput, __assign({ classes: {
                        root: classes.inputRoot,
                        input: classes.input
                    } }, props, { disableUnderline: true })),
        error ?
            React.createElement(ErrorTooltip, { title: error, className: classes.errorIcon },
                React.createElement(ErrorOutlineIcon, null))
            : null));
});
export var BaseSelect = withStyles({
    column: {
        flexDirection: "column",
    },
    row: {
        flexDirection: 'row',
    },
    root: {
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        flex: 2,
        '&:focus-within': {
            color: '#1084D3',
            '& .label': {
                color: '#1084D3',
            }
        },
        '&.error': {
            color: '#FF274B !important',
            '& .label': {
                color: '#FF274B !important',
            }
        },
        '& .MuiInputBase-root': {
            backgroundColor: function (props) { return props.disabled ? '#F9F9F9' : 'white'; },
            '&:hover': {},
        }
    },
    label: {},
    selectRoot: {
        '&:focus': {
            backgroundColor: '#F6FCFF',
            borderColor: '#1084D3'
        },
    },
    select: {},
    selectInputRoot: {
        borderRadius: 0,
        display: 'flex',
        flexGrow: 1
    },
    selectInput: {
        padding: 7,
    }
})(function (_a) {
    var label = _a.label, children = _a.children, $value = _a.$value, classes = _a.classes, props = __rest(_a, ["label", "children", "$value", "classes"]);
    var ro = useContext(ReadOnly) || props.readOnly || !$value || props.disabled, error = (!ro && $value.error) || '', maybeError = error ? ' error' : '';
    return (label ?
        React.createElement("label", { className: classes.root + ' ' + classes.row + maybeError },
            React.createElement("span", { className: classes.label + ' label' },
                label,
                (props.required === undefined && error === 'Required') || (props.required && !ro) ?
                    React.createElement("span", { className: classes.required }, "*")
                    : null),
            React.createElement(Select, __assign({ classes: {
                    root: classes.selectRoot + ' select-root',
                    select: classes.select
                }, readOnly: ro, input: React.createElement(BaseSelectInput, { classes: {
                        root: classes.selectInputRoot + ' select-input-root',
                        input: classes.selectInput
                    }, "$value": $value, error: error }), native: false }, props), children))
        :
            React.createElement("div", { className: classes.root + ' ' + classes.row + maybeError },
                React.createElement(Select, __assign({ classes: {
                        root: classes.selectRoot + ' select-root',
                        select: classes.select
                    }, readOnly: ro, input: React.createElement(BaseSelectInput, { classes: {
                            root: classes.selectInputRoot + ' select-input-root',
                            input: classes.selectInput
                        }, "$value": $value, error: error }), native: false }, props), children)));
});
export var PickItem = function (_a) {
    var items = _a.items, filter = _a.filter, onChange = _a.onChange, $value = _a.$value, format = _a.format, _b = _a.maxLength, maxLength = _b === void 0 ? 10 : _b, preserveFilter = _a.preserveFilter, children = _a.children, bottom = _a.bottom, $showDropdown = _a.$showDropdown, showMore = _a.showMore, label = _a.label, insidePopup = _a.insidePopup, rest = __rest(_a, ["items", "filter", "onChange", "$value", "format", "maxLength", "preserveFilter", "children", "bottom", "$showDropdown", "showMore", "label", "insidePopup"]);
    var classes = usePickItemStyles({ insidePopup: insidePopup }), ro = useContext(ReadOnly) || rest.readOnly || !$value || rest.disabled, error = ro ? '' : $value.error;
    var $show = $showDropdown || useLinked(false);
    var $length = useLinked(maxLength);
    var $filter = useLinked(''), value = $filter.value;
    var filtered = items.filter(function (x) { return !value || filter(x, value); });
    var $options = useLinked([]);
    React.useEffect(function () {
        var options = [];
        var _loop_1 = function (i) {
            var el = filtered[i];
            options.push(React.createElement("li", { key: el.cid || i, onMouseDown: function () {
                    $value && $value.set(el);
                    onChange && onChange(el);
                } }, children(el, i)));
        };
        for (var i = 0; i < $length.value && i < filtered.length; i++) {
            _loop_1(i);
        }
        if (!filtered.length) {
            options.push(React.createElement("div", null, "No results, refine the filter"));
        }
        if (filtered.length > $length.value) {
            options.push(React.createElement("div", { onMouseDown: function (e) {
                    if (showMore) {
                        e.stopPropagation();
                        e.preventDefault();
                        addMoreOptions();
                    }
                } }, showMore ? "Show more (" + (filtered.length - $length.value) + ")" : filtered.length - $length.value + " more"));
        }
        else if (bottom) {
            options.push(bottom);
        }
        $options.set(options);
    }, [$show.value, $filter.value, $length.value]);
    var addMoreOptions = function () {
        $length.set($length.value + maxLength);
    };
    return (label ?
        React.createElement("label", { className: classes.root },
            React.createElement("span", { className: classes.label },
                label,
                (rest.required === undefined && error === 'Required') || (rest.required && !ro && !$value.value) ?
                    React.createElement("span", { className: classes.required }, "*")
                    : null),
            React.createElement("div", { className: classes.pickItemRoot, onFocus: ro ? $show.false : $show.true, onBlur: function () {
                    preserveFilter || $filter.set('');
                    $show.false();
                } }, $show.isTruthy ?
                React.createElement(React.Fragment, null,
                    React.createElement(Input, __assign({ "$value": $filter, readOnly: ro }, rest)),
                    React.createElement("ul", null, $options.value))
                :
                    React.createElement(Input, __assign({ readOnly: ro, "$value": Linked.value(format ? format($value.value) : $filter.value, function (x) { return undefined; }) }, rest))))
        : React.createElement("div", { className: classes.pickItemRoot, onFocus: $show.true, onBlur: function () {
                preserveFilter || $filter.set('');
                $show.false();
            } }, $show.isTruthy ?
            React.createElement(React.Fragment, null,
                React.createElement(Input, __assign({ "$value": $filter }, rest)),
                React.createElement("ul", null, $options.value))
            :
                React.createElement(Input, __assign({ "$value": Linked.value(format ? format($value.value) : $filter.value, function (x) { return undefined; }) }, rest))));
};
var usePickItemStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,
        marginBottom: 8,
        '&:focus-within': {
            color: '#1084D3',
            fontWeight: 600,
        }
    },
    label: {
        flex: 2,
        alignSelf: 'center',
    },
    pickItemRoot: {
        flex: 3,
        '& ul': {
            listStyleType: 'none',
            margin: '4px 0 0 0',
            padding: 0,
            position: function (props) { return props.insidePopup ? 'fixed' : 'absolute'; },
            backgroundColor: 'white',
            boxShadow: '1px 1px 2px 0px #808080',
            'z-index': 10,
            maxHeight: '450px',
            overflow: 'auto',
            '& li': {
                cursor: "pointer",
                padding: '0.5em',
                '&:hover': {
                    backgroundColor: 'whitesmoke'
                }
            }
        }
    },
    required: {
        color: colors.red,
        verticalAlign: 'middle',
        fontSize: 16,
        paddingLeft: 4,
    }
});
//# sourceMappingURL=select.js.map